import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import EqualizerIcon from '@mui/icons-material/InsertChartOutlined';
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

import { AutoSaveProvider, useAutoSaveState, useAutoSave, SaveButton, NameField } from '../lib/useAutoSaveState'
import recoil from '../lib/recoil'
import toFixed from '../lib/toFixed'

function Recoil() {
  const [ rifleWeight, setRifleWeight ] = useAutoSaveState('rifleWeight', '')
  const [ bulletWeight, setBulletWeight ] = useAutoSaveState('bulletWeight', '')
  const [ powderWeight, setPowderWeight ] = useAutoSaveState('powderWeight', '')
  const [ velocity, setVelocity ] = useAutoSaveState('velocity', '')
  const [ f, setF ] = useAutoSaveState('f', '1.75')
  const [ preview, setPreview ] = useAutoSaveState('preview', null)
  const [ result, setResult ] = useState('')

  const calculate = () => {
    const recoilResult = recoil(
      parseFloat(rifleWeight),
      parseFloat(bulletWeight),
      parseFloat(powderWeight),
      parseFloat(velocity),
      parseFloat(f)
    )
    setResult(recoilResult)
    setPreview(`Recoil Energy: ${toFixed(recoilResult.freeRecoilEnergy, 1)} ft⋅lb, Recoil Velocity: ${toFixed(recoilResult.recoilVelocity, 1)} fps`)
    window.gtag('event', 'calculate-recoil')
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3} justifyContent="center" >
        <Grid container justifyContent="center" xs={12} sx={{ position: 'relative' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            Recoil Estimation
          </Typography>
          <SaveButton />
        </Grid>
        <NameField />
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField fullWidth label="Bullet Weight" autoFocus value={bulletWeight} onChange={e => setBulletWeight(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">grains</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Bullet Velocity" value={velocity} onChange={e => setVelocity(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">fps</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Powder Weight" value={powderWeight} onChange={e => setPowderWeight(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">grains</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Rifle Weight" value={rifleWeight} onChange={e => setRifleWeight(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">lbs</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Scale Factor</InputLabel>
                  <Select
                    value={f}
                    label="Scale Factor"
                    onChange={e => setF(e.target.value)}
                  >
                    <MenuItem value="1.75">Rifle</MenuItem>
                    <MenuItem value="1.5">Shotgun</MenuItem>
                    <MenuItem value="1.5">Pistol</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Button variant="contained" onClick={calculate}>Calculate</Button>
            </Grid>
          </Paper>
        </Grid>
        {result && <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Typography variant="h5" gutterBottom>
                <EqualizerIcon /> Results
              </Typography>
            </Grid>
            <Divider style={{ marginBottom: '20px', marginTop: '20px' }} />
            <Box display="flex" justifyContent="space-around" mb={2}>
              <Typography variant="h5"><b>Recoil Energy:</b> {toFixed(result.freeRecoilEnergy, 1)} ft⋅lb</Typography>
            </Box>
            <Box display="flex" justifyContent="space-around" mb={2}>
              <Typography variant="h5"><b>Recoil Velocity:</b> {toFixed(result.recoilVelocity, 1)} fps</Typography>
            </Box>
          </Paper>
        </Grid>}
      </Grid>
    </Container>
  );
}

const RecoilWithProvider = () => (
  <AutoSaveProvider type="recoil">
    <Recoil />
  </AutoSaveProvider>
)

export default RecoilWithProvider
